import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { COLORS } from 'config/theme/baseTheme';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    statusBadge: {
      alignItems: 'center',
      borderRadius: theme.spacing(1.5),
      padding: theme.spacing(1, 1.5),
      margin: theme.spacing(0.5, 1, 0.5, 0),
      border: `0.5px solid`,
      width: 'auto',
      '& .icon': {
        width: 16,
        height: 16,
        marginRight: theme.spacing(1),
        fill:"none"
      },
      '& .label': {
        fontSize: 13,
        fontWeight: 600,
      },
      '&.success': {
        backgroundColor: COLORS.F0FDF4,
        borderColor: COLORS.BG008732,
        '& .label': {
          color: COLORS.BG008732,
        },
        '& .icon': {
          color: COLORS.BG008732,
        },
      },
      '&.danger': {
        backgroundColor: COLORS.COLOR_FAD6D6,
        borderColor: COLORS.COLOR_8D2625,
        '& .label': {
          color: COLORS.COLOR_8D2625,
        },
        '& .icon': {
          color: COLORS.COLOR_8D2625,
        },
      },
    },
  })
);
